module.exports = "/assets/data/41d8440afd722624c7992bda04224339-TW7.data.json";